import { render, staticRenderFns } from "./TouristGroupSelector.vue?vue&type=template&id=b5b2294a&"
import script from "./TouristGroupSelector.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TouristGroupSelector.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TouristGroupSelector.vue?vue&type=style&index=0&id=b5b2294a&prod&lang=css&"
import style1 from "./TouristGroupSelector.vue?vue&type=style&index=1&id=b5b2294a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports